import Swal from 'sweetalert2';
import InfoErrorIcon from '../../assets/img/carga excedida.svg';
import InfoIcon from '../../assets/img/carga duplicada.svg';
import './styles.css';

export const confirmSevenDigitDni = async () => {
    const first = await Swal.fire({
        title: "Verificación de Documento",
        text: "Ha cargado un documento con 7 caracteres. Usualmente constan de 8. ¿Desea revisar el dato ingresado?",
        imageUrl: InfoErrorIcon,
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: "Advertencia",
        showDenyButton: true,
        reverseButtons: true,
        confirmButtonText: "Continuar",
        denyButtonText: "Corregir",
        buttonsStyling: false,
        customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            htmlContainer: "custom-swal-text",
            confirmButton: "custom-swal-deny-button",
            denyButton: "custom-swal-button",
            actions: "custom-swal-actions",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
    });

    if (!first.isConfirmed) {
        return false;
    }

    const second = await Swal.fire({
        title: "Aviso",
        html: "El sistema agregará automáticamente un cero al inicio,<br>en cumplimiento con la reglamentación nacional vigente.",
        imageUrl: InfoIcon,
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: "Información",
        confirmButtonText: "Entendido y Enviar",
        buttonsStyling: false,
        customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            htmlContainer: "custom-swal-text",
            confirmButton: "custom-swal-button",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
    });

    return second.isConfirmed;
};
